module.exports = __webpack_public_path__ + "img/end-page.1b3957fa.jpg";